import { render, staticRenderFns } from "./PageGenerator.vue?vue&type=template&id=035296c1&scoped=true"
import script from "./PageGenerator.vue?vue&type=script&lang=js"
export * from "./PageGenerator.vue?vue&type=script&lang=js"
import style0 from "./PageGenerator.vue?vue&type=style&index=0&id=035296c1&prod&scoped=true&lang=css"
import style1 from "./PageGenerator.vue?vue&type=style&index=1&id=035296c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_b5d88ca7d6e3b024e45c8e5733387931/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035296c1",
  null
  
)

export default component.exports